export const FacetKeys: InterestsFacetKey[] = ['levels', 'products', 'roles'];

export type InterestsFacetKey = 'levels' | 'products' | 'roles';

export interface Interests {
	products: string[];
	roles: string[];
	levels: string[];
}
